import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getBlogDetailById = createAsyncThunk(
  "blogDetailById/getBlogListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/blog/get_by_id`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const blogDetailSlice = createSlice({
  name: "blogDetailById",
  initialState: {
    loading: false,
    blogDetailByIdData: null,
    error: null,
  },
  reducers: {
    ResetbBlogDetailDataState: (state) => {
      state.loading = false;
      state.blogDetailByIdData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBlogDetailById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBlogDetailById.fulfilled, (state, action) => {
        state.loading = false;
        state.blogDetailByIdData = action.payload;
      })
      .addCase(getBlogDetailById.rejected, (state, action) => {
        state.loading = false;
        state.blogDetailByIdData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetbBlogDetailDataState } = blogDetailSlice.actions;
export default blogDetailSlice.reducer;
